import { render, staticRenderFns } from "./FaultSummary.vue?vue&type=template&id=f20503d2"
import script from "./FaultSummary.vue?vue&type=script&lang=js"
export * from "./FaultSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports